/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Bucket } from './bucket';


export interface ServizioMensaRicaricheStatisticheDTO { 
    totale?: Bucket;
    per_mese?: Array<Bucket>;
}

